import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';
import React, { SyntheticEvent, useContext } from 'react';
import { connect, useDispatch } from 'react-redux';
import { ActionCreatorsMapObject, bindActionCreators, Dispatch } from 'redux';
import { IConfirmationAction, IConfirmationState } from './ConfirmationModel';
import * as confirmActions from './ConfirmationActions';
import * as dashboardActions from '../Workspace/Dashboard/DashboardActions';
import { securityActions } from '../Workspace/Security/SecurityActions';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../containers/AppProviderWrapper';

export interface IConfirmationProps {
    confirmation?: IConfirmationState;
    actions: ActionCreatorsMapObject;
}

export const ConfirmationDialog: React.FC<IConfirmationProps> = ({
    confirmation,
    actions,
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { handleClickOpenContact } = useContext(AppContext);

    const handleCancel = (e: SyntheticEvent) => {
        if (e) {
            e.preventDefault();
        }
        // TODO
        actions.hideConfirmation();
    };

    const handleOk = (e: SyntheticEvent) => {
        if (e) {
            e.preventDefault();
        }
        if (confirmation.type === 'removeFilter') {
            dispatch(dashboardActions.setFilters(confirmation.param1));
        }
        if (confirmation.type === 'cancelInvitation') {
            dispatch(securityActions.cancelInvitation(confirmation.param1));
        }
        if (confirmation.type === 'revokeAccess') {
            dispatch(
                securityActions.revokeAccess(
                    confirmation.param1,
                    confirmation.param2
                )
            );
        }
        if (confirmation.type === 'acceptInvitation') {
            dispatch(
                securityActions.invitationResponse(
                    confirmation.param1,
                    confirmation.param2
                )
            ).then(() => {
                navigate(`/workspace/${confirmation.param3}`);
            });
        }
        if (confirmation.type === 'rejectInvitation') {
            dispatch(
                securityActions.invitationResponse(
                    confirmation.param1,
                    confirmation.param2
                )
            );
        }
        if (confirmation.type === 'reInvite') {
            dispatch(
                securityActions?.inviteUser(
                    confirmation.param1,
                    confirmation.param2,
                    confirmation.param3
                )
            );
        }
        if (confirmation.type === 'deleteWorkspace') {
            dispatch(securityActions.deleteWorkspace(confirmation.param1)).then(
                () => {
                    navigate(`/`);
                }
            );
        }
        if (confirmation.type === 'unableDeleteWorkspace') {
            handleClickOpenContact();
        }

        // TODO
        actions.hideConfirmation();
    };

    return (
        <Dialog
            open={!!(confirmation && confirmation.visible)}
            disableEscapeKeyDown
            maxWidth="xs"
            aria-labelledby="confirmation-dialog-title"
        >
            <DialogTitle id="confirmation-dialog-title">
                {confirmation && confirmation.title}
            </DialogTitle>
            <DialogContent>
                <Typography variant="body1">
                    {confirmation && confirmation.message}
                </Typography>
            </DialogContent>
            <DialogActions>
                <div>
                    {confirmation?.type !== 'unableDelete' && (
                        <Button
                            onClick={handleCancel}
                            color="primary"
                            style={{ marginRight: 8 }}
                        >
                            Cancel
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        onClick={handleOk}
                        style={{
                            backgroundColor:
                                confirmation.type === 'deleteWorkspace'
                                    ? '#B30000'
                                    : '#325599',
                        }}
                    >
                        {confirmation.type === 'deleteWorkspace'
                            ? 'Delete Workspace'
                            : confirmation.type === 'unableDeleteWorkspace'
                            ? 'Contact Support'
                            : 'Confirm'}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
};

function mapStateToProps(store: any) {
    return {
        confirmation: store.confirmation,
    };
}

function mapDispatchToProps(dispatch: Dispatch<IConfirmationAction>) {
    return {
        actions: bindActionCreators(confirmActions.actions, dispatch),
    };
}

// middleware
export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationDialog);
